import { render, staticRenderFns } from "./StartLinkFromTemplate.vue?vue&type=template&id=1c66c849&"
import script from "./StartLinkFromTemplate.vue?vue&type=script&lang=js&"
export * from "./StartLinkFromTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports